// components/RightSideSummary.jsx
import { PencilIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

const RightSideSummary = ({ 
  bookingSummary: initialBookingSummary,
  vehicleDetails: propVehicleDetails,
  transportType = "open",
  onBookingSummaryChange,
  onVehicleConditionChange,
  onTransportTypeChange,
  editable = false,
  updatingPrice = false,
  priceDetails = {
    dueNow: "$0",
    totalDue: "$1013"
  }
}) => {
  const [bookingSummary, setBookingSummary] = useState(initialBookingSummary || {
    distance: "623 mi",
    firstAvailableDate: "Dec 10, 2025",
    shipFrom: "Manassas, VA",
    shipTo: "Los Angeles, CA",
    transportType: "Open",
    serviceType: "Door to Door",
    insurance: "Included",
    transitTime: "3–5 Days"
  });

  const vehicleDetails = propVehicleDetails || {
    vehicleMake: "2024 Alfa Romeo",
    vehicleModel: "Stelvio",
    vehicleCondition: "Running"
  };

  console.log(bookingSummary,'bookingSummary')
  const [editingField, setEditingField] = useState(null);
  const [showTransportOptions, setShowTransportOptions] = useState(false);
  // const [showConditionOptions, setShowConditionOptions] = useState(false);

  // Handle booking summary field edit
  const handleEditField = (fieldName, currentValue) => {
    if (!editable) return;
    setEditingField({ fieldName, currentValue });
  };

  // Handle save edit
  const handleSaveEdit = (fieldName, newValue) => {
    const updated = { ...bookingSummary, [fieldName]: newValue };
    setBookingSummary(updated);
    onBookingSummaryChange?.(updated);
    setEditingField(null);
  };

  // Handle transport type selection
  const handleTransportSelect = (type) => {
    const newType = type === "enclosed" ? "Enclosed" : "Open";
    const updated = { ...bookingSummary, transportType: newType };
    setBookingSummary(updated);
    onBookingSummaryChange?.(updated);
    onTransportTypeChange?.(type);
    setShowTransportOptions(false);
  };

  return (
    <div className="w-full lg:w-[32%] space-y-6">
      {/* BOOKING SUMMARY */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-2">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-[#103558]">Booking summary</h3>
          {editable && (
            <button 
              onClick={() => setEditingField('all')}
              className="flex items-center gap-1 text-sm text-[#00A1EF] hover:text-[#0088CC]"
            >
              <PencilIcon className="w-4 h-4" />
              Edit All
            </button>
          )}
        </div>
        
        {/* DISTANCE */}
        <div className="flex justify-between items-center py-3 border-b border-gray-100 text-sm group">
          <span className="text-gray-600">Distance</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.distance}</span>
            {editable && (
              <button 
                onClick={() => handleEditField("distance", bookingSummary.distance)}
                className="opacity-0 group-hover:opacity-100 transition-opacity text-[#00A1EF] hover:text-[#0088CC] p-1"
              >
                <PencilIcon className="w-3 h-3" />
              </button>
            )}
          </div>
        </div>

        {/* FIRST AVAILABLE DATE */}
        <div className="flex justify-between items-center py-3 border-b border-gray-100 text-sm group">
          <span className="text-gray-600">Pick Date</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.firstAvailableDate}</span>
            {editable && (
              <button 
                onClick={() => handleEditField("firstAvailableDate", bookingSummary.firstAvailableDate)}
                className="opacity-0 group-hover:opacity-100 transition-opacity text-[#00A1EF] hover:text-[#0088CC] p-1"
              >
                <PencilIcon className="w-3 h-3" />
              </button>
            )}
          </div>
        </div>

        {/* SHIP FROM */}
        <div className="flex justify-between items-center py-3 border-b border-gray-100 text-sm group">
          <span className="text-gray-600">Ship from</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.shipFrom}</span>
            {editable && (
              <button 
                onClick={() => handleEditField("shipFrom", bookingSummary.shipFrom)}
                className="opacity-0 group-hover:opacity-100 transition-opacity text-[#00A1EF] hover:text-[#0088CC] p-1"
              >
                <PencilIcon className="w-3 h-3" />
              </button>
            )}
          </div>
        </div>

        {/* SHIP TO */}
        <div className="flex justify-between items-center py-3 border-b border-gray-100 text-sm group">
          <span className="text-gray-600">Ship to</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.shipTo}</span>
            {editable && (
              <button 
                onClick={() => handleEditField("shipTo", bookingSummary.shipTo)}
                className="opacity-0 group-hover:opacity-100 transition-opacity text-[#00A1EF] hover:text-[#0088CC] p-1"
              >
                <PencilIcon className="w-3 h-3" />
              </button>
            )}
          </div>
        </div>

        {/* TRANSPORT TYPE - EDITABLE FIELD WITH DROPDOWN */}
        <div className="py-3 border-b border-gray-100">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-gray-600">Transport type</span>
            {editable && (
              <button 
                onClick={() => setShowTransportOptions(!showTransportOptions)}
                disabled={updatingPrice}
                className="flex items-center gap-1 text-sm text-[#00A1EF] hover:text-[#0088CC] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {updatingPrice && bookingSummary.transportType === (transportType === "enclosed" ? "Enclosed" : "Open") ? (
                  <div className="flex items-center gap-1.5">
                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-[#00A1EF]"></div>
                    <span className="text-xs text-gray-500">Updating</span>
                  </div>
                ) : (
                  <>
                    <PencilIcon className="w-3 h-3" />
                    Change
                  </>
                )}
              </button>
            )}
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className={`w-3 h-3 rounded-full ${transportType === "enclosed" ? "bg-[#00A1EF]" : "bg-gray-300"}`}></div>
              <span className="font-medium text-[#103558]">{bookingSummary.transportType}</span>
            </div>
            
            {/* TRANSPORT TYPE DESCRIPTION */}
            <span className="text-xs text-gray-500">
              {transportType === "enclosed" ? "Maximum protection" : "Most economical"}
            </span>
          </div>

          {/* TRANSPORT OPTIONS DROPDOWN */}
          {showTransportOptions && editable && (
            <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
              <div className="space-y-2">
                {/* OPEN TRANSPORT OPTION */}
                <button
                  onClick={() => handleTransportSelect("open")}
                  className={`w-full flex items-center justify-between p-3 rounded-lg border text-left transition-all duration-200 ${
                    transportType === "open" 
                    ? "border-[#00A1EF] bg-white shadow-sm" 
                    : "border-gray-200 bg-white hover:bg-gray-50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                      transportType === "open" 
                      ? "border-[#00A1EF] bg-[#00A1EF]" 
                      : "border-gray-300"
                    }`}>
                      {transportType === "open" && (
                        <svg className="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                    <div>
                      <div className="font-medium text-gray-900">Open Transport</div>
                      <div className="text-xs text-gray-500">Most economical option</div>
                    </div>
                  </div>
                  {transportType === "open" && updatingPrice && (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#00A1EF]"></div>
                  )}
                </button>

                {/* ENCLOSED TRANSPORT OPTION */}
                <button
                  onClick={() => handleTransportSelect("enclosed")}
                  className={`w-full flex items-center justify-between p-3 rounded-lg border text-left transition-all duration-200 ${
                    transportType === "enclosed" 
                    ? "border-[#00A1EF] bg-white shadow-sm" 
                    : "border-gray-200 bg-white hover:bg-gray-50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                      transportType === "enclosed" 
                      ? "border-[#00A1EF] bg-[#00A1EF]" 
                      : "border-gray-300"
                    }`}>
                      {transportType === "enclosed" && (
                        <svg className="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                    <div>
                      <div className="font-medium text-gray-900">Enclosed Transport</div>
                      <div className="text-xs text-gray-500">Maximum protection</div>
                    </div>
                  </div>
                  {transportType === "enclosed" && updatingPrice && (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#00A1EF]"></div>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* SERVICE TYPE */}
        <div className="flex justify-between items-center py-3 border-b border-gray-100 text-sm group">
          <span className="text-gray-600">Service type</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.serviceType}</span>
            {/* {editable && (
              <button 
                onClick={() => handleEditField("serviceType", bookingSummary.serviceType)}
                className="opacity-0 group-hover:opacity-100 transition-opacity text-[#00A1EF] hover:text-[#0088CC] p-1"
              >
                <PencilIcon className="w-3 h-3" />
              </button>
            )} */}
          </div>
        </div>

        {/* INSURANCE */}
        <div className="flex justify-between items-center py-3 border-b border-gray-100 text-sm group">
          <span className="text-gray-600">Insurance</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.insurance}</span>
         
          </div>
        </div>

        {/* TRANSIT TIME */}
        <div className="flex justify-between items-center py-3 text-sm group">
          <span className="text-gray-600">Transit time</span>
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#103558]">{bookingSummary.transitTime}</span>
          
          </div>
        </div>
      </div>

      {/* VEHICLE DETAILS */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-[#103558] mb-4">Vehicle details</h3>
        
        {/* VEHICLE INFO */}
        <div className="bg-gray-50 rounded-lg p-4 mb-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-xs text-gray-500 mb-1">VEHICLE #1</p>
              <p className="text-base font-semibold text-[#103558] leading-tight">
                {vehicleDetails.vehicleMake}
              </p>
              <p className="text-sm text-gray-600">{vehicleDetails.vehicleModel}</p>
            </div>
            <div className="text-right">
              <div className={`inline-block px-3 py-1 rounded-md text-sm font-medium mb-2 ${
                vehicleDetails.vehicleCondition === "Running" 
                ? "bg-green-100 text-green-800" 
                : "bg-amber-100 text-amber-800"
              }`}>
                {updatingPrice ? (
                  <div className="flex items-center gap-2">
                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-current"></div>
                    Updating
                  </div>
                ) : vehicleDetails.vehicleCondition}
              </div>
              <p className="text-xs text-gray-500">Condition</p>
            </div>
          </div>
        </div>

        {/* CONDITION SELECTOR */}
        <div>
          <div className="flex justify-between items-center mb-3">
            <p className="text-sm font-medium text-gray-700">Select condition</p>
            {updatingPrice && (
              <div className="flex items-center gap-1.5 text-xs text-gray-500">
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400"></div>
                Updating price
              </div>
            )}
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => onVehicleConditionChange && onVehicleConditionChange("Running")}
              disabled={updatingPrice}
              className={`p-4 rounded-lg border text-left transition-all duration-200 ${
                vehicleDetails.vehicleCondition === "Running" 
                ? "border-[#00A1EF] bg-[#00A1EF]/5" 
                : "border-gray-200 hover:bg-gray-50"
              } ${updatingPrice ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  vehicleDetails.vehicleCondition === "Running" 
                  ? "border-[#00A1EF] bg-[#00A1EF]" 
                  : "border-gray-300"
                }`}>
                  {vehicleDetails.vehicleCondition === "Running" && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
                <div>
                  <span className="font-medium text-gray-900 block">Running</span>
                  {/* <span className="text-xs text-gray-500">Vehicle starts & drives</span> */}
                </div>
              </div>
            </button>
            
            <button
              onClick={() => onVehicleConditionChange && onVehicleConditionChange("Non-Running")}
              disabled={updatingPrice}
              className={`p-4 rounded-lg border text-left transition-all duration-200 ${
                vehicleDetails.vehicleCondition === "Non-Running" 
                ? "border-[#00A1EF] bg-[#00A1EF]/5" 
                : "border-gray-200 hover:bg-gray-50"
              } ${updatingPrice ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              <div className="flex items-center gap-3">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  vehicleDetails.vehicleCondition === "Non-Running" 
                  ? "border-[#00A1EF] bg-[#00A1EF]" 
                  : "border-gray-300"
                }`}>
                  {vehicleDetails.vehicleCondition === "Non-Running" && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
                <div>
                  <span className="font-medium text-gray-900 block">Non-Running</span>
                  {/* <span className="text-xs text-gray-500">Doesn't start or drive</span> */}
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* PAYMENT SUMMARY */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        <div className="bg-blue-50 p-4 rounded-lg">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm font-medium text-blue-700">Due now</p>
              <p className="text-3xl font-bold text-blue-700">{priceDetails.dueNow}</p>
            </div>
            <div className="text-right">
              <div className="inline-flex items-center gap-1.5 text-blue-600 text-sm">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                No payment to book
              </div>
            </div>
          </div>
        </div>
        
        <p className="text-sm text-gray-500 px-1">
          Don't worry — you won't pay until your pickup is scheduled.
        </p>
        
        <div className="border-t pt-4">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-lg font-bold text-[#103558]">{priceDetails.priceLabel}</p>
              <p className="text-sm text-gray-500">After carrier assignment</p>
            </div>
            <div className="text-right">
              <p className="text-3xl font-bold text-[#103558]">
                {updatingPrice ? (
                  <div className="flex items-center gap-2 text-gray-500">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-400"></div>
                    Updating
                  </div>
                ) : priceDetails.totalDue}
              </p>
              {updatingPrice && (
                <p className="text-xs text-gray-400 mt-1">Recalculating your price</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      {editingField && editable && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h3 className="text-lg font-semibold text-[#103558] mb-4">
              Edit {editingField === 'all' ? 'All Fields' : 'Field'}
            </h3>
            
            {editingField === 'all' ? (
              <div className="space-y-4">
                {Object.entries(bookingSummary).map(([field, value]) => (
                  <div key={field}>
                    <label className="block text-sm font-medium text-gray-700 mb-1 capitalize">
                      {field.replace(/([A-Z])/g, ' $1').toLowerCase()}
                    </label>
                    <input
                      type="text"
                      value={value}
                      onChange={(e) => {
                        const updated = { ...bookingSummary, [field]: e.target.value };
                        setBookingSummary(updated);
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#00A1EF] focus:border-transparent"
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Edit {editingField.fieldName.replace(/([A-Z])/g, ' $1').toLowerCase()}
                </label>
                <input
                  type="text"
                  defaultValue={editingField.currentValue}
                  onBlur={(e) => handleSaveEdit(editingField.fieldName, e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#00A1EF] focus:border-transparent"
                  autoFocus
                />
              </div>
            )}
            
            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setEditingField(null)}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              {editingField === 'all' && (
                <button
                  onClick={() => setEditingField(null)}
                  className="flex-1 px-4 py-2 bg-[#00A1EF] text-white rounded-lg hover:bg-[#0088CC]"
                >
                  Save All
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RightSideSummary;